module.exports = __webpack_public_path__ + "Flama-Semibold.ttf?edfda2b997b329dead1ad549629821d2";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Semibold.ttf
// module id = 937
// module chunks = 0